export const LEGAL_TEXTS = {
  NO_IMPACT:
    "La parcelle n’est concernée par aucune obligation réglementaire acoustique liée au bruit des transports (classement sonore ; Plan d’Exposition au Bruit).",
  SOUNDCLASSIFICATION: {
    INTRODUCTION: "Secteurs du classement sonore impactant la parcelle",

    DETAILS: {
      ISOLATION_TABLE:
        "Exemple d'isolement(s) théorique(s) pour une position du bâti la plus défavorable (proche de la source)",
      NOTICE: `* Distance issue du point de la parcelle le plus proche du milieu de la source. Attention : Cela ne correspond pas à la distance règlementaire requise : la règlementation impose le calcul de la distance entre le bord exterieur de la source (chaussée ou voie ferrée) et la façade du bâtiment concerné.`,
    },
  },
};
